<template>
	<div>
		<div class="footer-message">
			<v-container class="py-0 fill-height">
				<v-row>
					<div class="col-md-9 col-xs-12 text-left terms">
						<v-list three-line>
							<v-list-item>
                              <template v-slot:default="{ active }">
                                <v-list-item-action left class="checkbox-top">
                                  <v-checkbox
                                    @change="changeAgrement()"
                                    class="custom-checkbox"
                                    v-model="terms_accepted"
                                    :input-value="active"
                                  ></v-checkbox>
                                </v-list-item-action>

                                <v-list-item-content class="terms-conditions-text">
                                  <span>
                                    {{ $t("terms_conditions") }}&nbsp;
                                    <a
                                      href="https://www.portasigma.com/politica-privacidad/"
                                      target="_blank"
                                      class="footer-link"
                                      rel="noopener"
                                    >{{ $t("privacy_policy") }}</a>
                                  </span>
                                </v-list-item-content>
                              </template>
                            </v-list-item>

						</v-list>
					</div>
					<div class="col-md-3 col-xs-12 see-document mt-md-5 mt-lg-5">
						<v-btn
                          x-large
                          block
                          :disabled="!agreed"
                          class="footer-text-btn"
                          @click="handleButtonClick()"
                        >
                          {{ $t("signer_form.next_button") }}
                        </v-btn>
					</div>
				</v-row>
			</v-container>
		</div>
		<access-modal :dialog="accessDialog" @closeModal="closeAccessModal" :typeOfId="typeOfId" :documentToken="Token" :documentId="$store.state.common.requestId"></access-modal>
	</div>
</template>

<script>
import AccessModal from "./AccessModal.component";
import { mapState, mapGetters } from 'vuex';
import FormsService from '../../services/forms-service.js';
import UploadService from "../../services/upload-service.js";

export default {
	components: {
		AccessModal
	},
	props: {
		isSigned: {
			type: Boolean,
			required: true
		},
		Token: {
			type: String,
			required: true
		},
		typeOfId: {
            type: String,
            required: true
        }
	},
	data() {
		return {
			terms_accepted: null,
			agreed: false,
			authCitizenId: null,
			accessDialog: false,
			AuthID: null,
			token: null,
			loading: false,
			hasAutoExecuted: false
		};
	},
	mounted() {
		this.authCitizenId = this.$route.query.auth || null;
		const bg = this.$store.state.common.buttonColor || '#F36E21';
        const txt = this.$store.state.common.buttonTextColor || '#FFFFFF';
        document.documentElement.style.setProperty('--btn-bg-color', bg);
        document.documentElement.style.setProperty('--btn-text-color', txt);

		this.checkAutoExecution();
	},
	watch: {
		status: {
			immediate: true,
			handler() {
				this.checkAutoExecution();
			}
		},
		isSigned: {
			immediate: true,
			handler() {
				this.checkAutoExecution();
			}
		}
	},
	computed: {
		auth() {
			return this.$store.state.common.auth;
		},
		status() {
			return this.$store.state.common.status;
		},
		hasAssociation() {
			return this.$store.getters['common/hasAssociation']
		},
		buttonText() {
			if (this.hasAttachments) {
				return 'See Attachments';
			}
			if (this.hasSignerForm && this.hasPendingSignerForm) {
				return this.$t("see_form");
			}
			return this.$t("see_document") + this.hasPendingSignerForm;
		},
		...mapState({
			SignRequestID: state => state.common.requestId,
		}),
		...mapGetters('attachments', [
			'hasAttachments', 'getTransactionApiToken'
		]),
		hasSignerForm() {
			return this.$store.getters['forms/hasSignerForm'];
		},
		hasPendingSignerForm() {
			return this.$store.getters['forms/hasPendingSignerForm'];
		}
	},
	methods: {
		checkAutoExecution() {
			if (this.hasAutoExecuted) return;

			if (this.status === 'SIGNED' || this.isSigned) {
				this.hasAutoExecuted = true;
				this.agreed = true;
				this.terms_accepted = true;
				this.$nextTick(() => {
					this.handleButtonClick();
				});
			}
		},
		changeAgrement() {
			this.agreed = !this.agreed;
		},
		authentication() {
			this.AuthID = localStorage.getItem("auth_id");
			// Si requiere DNI y aún no existe un auth_id guardado, abrimos el modal
			if (this.authCitizenId === "citizenid" && !this.AuthID) {
				this.authPopUp();
			} else {
				// Si no requiere DNI o ya lo introdujo previamente, avanzamos directo
				this.closeAccessModal();
			}
		},
		pdfView() {
			this.authentication();
		},
		closeModal() {
			this.agreed = false;
			this.terms_accepted = null;
			this.authentication();
		},
		authPopUp() {
			this.accessDialog = true;
		},
		async closeAccessModal() {
			this.accessDialog = false;
			this.AuthID = localStorage.getItem("auth_id");

			// REDIRECCIÓN DIRECTA SI YA ESTÁ FIRMADO (Evita llamadas a formularios y adjuntos)
			if (this.status === 'SIGNED' || this.isSigned) {
				this.$router.push({
					name: `${this.hasAssociation ? 'custom-' : ''}pdf-viewer`,
					query: {
						token: this.Token,
						auth_id: this.AuthID
					}
				});
				return;
			}

			// Lógica previa mantenida para peticiones pendientes de firma
			await this.loadDocumentData(this.SignRequestID, this.AuthID);

			let docCountRaw = await this.getUploadedDocCount(this.SignRequestID, this.Token, this.AuthID);
            let docCount = Number(docCountRaw);

            if (isNaN(docCount)) {
                console.error('docCount is not a number:', docCount);
                docCount = 0;
            }

			if (this.hasAttachments && docCount == 0  && this.hasPendingSignerForm && this.hasSignerForm) {
				this.$router.push({
					name: `${this.hasAssociation ? 'custom-' : ''}attachments`,
					query: { token: this.Token, auth_id: this.AuthID }
				});
			} else if (this.hasAttachments && (docCount > 0) && this.hasPendingSignerForm && this.hasSignerForm) {
				this.$router.push({
					name: `${this.hasAssociation ? 'custom-' : ''}forms`,
					query: { token: this.Token, auth_id: this.AuthID }
				});
			} else if (!this.hasAttachments && this.hasPendingSignerForm && this.hasSignerForm) {
				this.$router.push({
					name: `${this.hasAssociation ? 'custom-' : ''}forms`,
					query: { token: this.Token, auth_id: this.AuthID }
				});
			}  else if (this.hasAttachments && (docCount > 0)  && !this.hasPendingSignerForm && this.hasSignerForm) {
				this.$router.push({
					name: `${this.hasAssociation ? 'custom-' : ''}pdf-viewer`,
					query: { token: this.Token, auth_id: this.AuthID }
				});
			} else if (!this.hasAttachments && !this.hasPendingSignerForm && !this.hasSignerForm) {
				this.$router.push({
					name: `${this.hasAssociation ? 'custom-' : ''}pdf-viewer`,
					query: { token: this.Token, auth_id: this.AuthID }
				});
			} else if (this.hasAttachments && !this.hasPendingSignerForm && !this.hasSignerForm) {
				this.$router.push({
					name: `${this.hasAssociation ? 'custom-' : ''}attachments`,
					query: { token: this.Token, auth_id: this.AuthID }
				});
			} else if (this.hasAttachments && !this.hasPendingSignerForm) {
				this.$router.push({
					name: `${this.hasAssociation ? 'custom-' : ''}pdf-viewer`,
					query: { token: this.Token, auth_id: this.AuthID }
				});
			} else if (!this.hasAttachments && !this.hasPendingSignerForm && this.hasSignerForm) {
				this.$router.push({
					name: `${this.hasAssociation ? 'custom-' : ''}pdf-viewer`,
					query: { token: this.Token, auth_id: this.AuthID }
				});
			}
		},
		signerFormView() {
			this.authentication();
		},
		handleButtonClick() {
			if (this.hasAttachments) {
				this.signerFormView();
			} else if (this.hasSignerForm && this.hasPendingSignerForm) {
				this.signerFormView();
			}
			this.pdfView();
		},
		async loadDocumentData(RequestID, AuthenticationID) {
			if (this.SignRequestID) {
				this.loading = true;
				try {
					const response = await FormsService.getFormStatus(RequestID, this.Token, AuthenticationID);
					this.requestDetails = response.data;
					this.$store.commit('forms/setHasSignerForm', this.requestDetails.hasSignerForm);
					this.$store.commit('forms/setHasPendingSignerForm', this.requestDetails.hasPendingSignerForm);
					this.$store.commit('attachments/setHasAttachments', this.requestDetails.hasAttachments);
					await this.$store.dispatch('attachments/setTransactionApiToken', this.requestDetails.apiToken);
					this.loading = false;
				} catch (error) {
					console.error('API Call Failed:', error);
					this.loading = false;
				}
			} else {
				console.log('No Request ID found');
			}
		},
		async getUploadedDocCount($request_id, $request_token, $request_auth_id) {
			try {
				const attachments = await UploadService.getAttachments($request_id, $request_token, $request_auth_id);
				return attachments.data.length;
			} catch (error) {
				console.error('Error in getUploadedDocCount:', error);
				return 0;
			}
		}
	}
};
</script>

<style scoped>
.checkbox-top {
  align-self: flex-start;
  margin-top: 6px;
  padding-top: 0;
}

.terms .v-list-item {
  align-items: flex-start;
}

.terms-conditions-text {
  display: block;
}
</style>